var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { schema } from 'lincd-schema/ontologies/schema';
import { Person as ProfilePicsPerson } from 'profile-pics/shapes/Person';
import { Literal } from 'lincd/models';
import { literalProperty } from 'lincd/shapes/SHACL';
import { profilePlus } from '../ontologies/profile-plus.js';
import { linkedShape } from '../package.js';
let Person = class Person extends ProfilePicsPerson {
    get smokingHabit() {
        //["Smoker", "Social smoker", "Smoker when drinking", "Trying to quit", "Non-smoker"]
        return this.getValue(profilePlus.smokingHabit);
    }
    set smokingHabit(val) {
        this.overwrite(profilePlus.smokingHabit, new Literal(val));
    }
    get drinkFrequency() {
        return this.getValue(profilePlus.drinkFrequency);
    }
    set drinkFrequency(val) {
        this.overwrite(profilePlus.drinkFrequency, new Literal(val));
    }
    get fourTwentyFriendly() {
        return this.getValue(profilePlus.fourTwentyFriendly);
    }
    set fourTwentyFriendly(val) {
        this.overwrite(profilePlus.fourTwentyFriendly, new Literal(val));
    }
    get languagePreference() {
        return this.getValue(profilePlus.languagePreference);
    }
    set languagePreference(val) {
        this.overwrite(profilePlus.languagePreference, new Literal(val));
    }
    get workoutFrequency() {
        return this.getValue(profilePlus.workoutFrequency);
    }
    set workoutFrequency(val) {
        this.overwrite(profilePlus.workoutFrequency, new Literal(val));
    }
    get workoutFrequencyNumber() {
        //["Everyday", "Often", "Sometimes", "Never"]
        switch (this.workoutFrequency) {
            case 'Everyday':
                return 3;
            case 'Often':
                return 2;
            case 'Sometimes':
                return 1;
            case 'Never':
                return 0;
        }
        return -1;
    }
    get passions() {
        return this.getAll(profilePlus.hasPassion);
    }
    get beliefs() {
        return this.getAll(profilePlus.hasBelief);
    }
    get systemIdeologies() {
        return this.getAll(profilePlus.hasSystemIdeology);
    }
    get coreValues() {
        return this.getAll(profilePlus.hasCoreValue);
    }
    get spiritualPractices() {
        return this.getAll(profilePlus.hasSpiritualPractice);
    }
    get sacredTexts() {
        return this.getAll(profilePlus.hasSacredText);
    }
    get mayanAstrology() {
        return this.getValue(profilePlus.hasMayanAstrology);
    }
    set mayanAstrology(val) {
        this.overwrite(profilePlus.hasMayanAstrology, new Literal(val));
    }
    get chineseZodiac() {
        return this.getValue(profilePlus.hasChineseZodiac);
    }
    set chineseZodiac(val) {
        this.overwrite(profilePlus.hasChineseZodiac, new Literal(val));
    }
    get myersBriggsPersonalityType() {
        return this.getValue(profilePlus.hasPersonalityType);
    }
    set myersBriggsPersonalityType(val) {
        this.overwrite(profilePlus.hasPersonalityType, new Literal(val));
    }
    get loveLanguage1() {
        return this.getValue(profilePlus.hasLoveLanguage1);
    }
    set loveLanguage1(val) {
        this.overwrite(profilePlus.hasLoveLanguage1, new Literal(val));
    }
    get loveLanguage2() {
        return this.getValue(profilePlus.hasLoveLanguage2);
    }
    set loveLanguage2(val) {
        this.overwrite(profilePlus.hasLoveLanguage2, new Literal(val));
    }
    get loveLanguage3() {
        return this.getValue(profilePlus.hasLoveLanguage3);
    }
    set loveLanguage3(val) {
        this.overwrite(profilePlus.hasLoveLanguage3, new Literal(val));
    }
    get loveLanguage4() {
        return this.getValue(profilePlus.hasLoveLanguage4);
    }
    set loveLanguage4(val) {
        this.overwrite(profilePlus.hasLoveLanguage4, new Literal(val));
    }
    get loveLanguage5() {
        return this.getValue(profilePlus.hasLoveLanguage5);
    }
    set loveLanguage5(val) {
        this.overwrite(profilePlus.hasLoveLanguage5, new Literal(val));
    }
    get spiritualJourney() {
        return this.getValue(profilePlus.hasSpiritualJourney);
    }
    set spiritualJourney(val) {
        this.overwrite(profilePlus.hasSpiritualJourney, new Literal(val));
    }
};
Person.targetClass = schema.Person;
__decorate([
    literalProperty({
        path: profilePlus.smokingHabit,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "smokingHabit", null);
__decorate([
    literalProperty({
        path: profilePlus.drinkFrequency,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "drinkFrequency", null);
__decorate([
    literalProperty({
        path: profilePlus.fourTwentyFriendly,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "fourTwentyFriendly", null);
__decorate([
    literalProperty({
        path: profilePlus.languagePreference,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "languagePreference", null);
__decorate([
    literalProperty({
        path: profilePlus.workoutFrequency,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "workoutFrequency", null);
__decorate([
    literalProperty({
        path: profilePlus.hasPassion,
        required: false,
        maxCount: 7,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "passions", null);
__decorate([
    literalProperty({
        path: profilePlus.hasBelief,
        required: false,
        maxCount: 5,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "beliefs", null);
__decorate([
    literalProperty({
        path: profilePlus.hasSystemIdeology,
        required: false,
        // maxCount: 5,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "systemIdeologies", null);
__decorate([
    literalProperty({
        path: profilePlus.hasCoreValue,
        required: false,
        // maxCount: 5,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "coreValues", null);
__decorate([
    literalProperty({
        path: profilePlus.hasSpiritualPractice,
        required: false,
        // maxCount: 5,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "spiritualPractices", null);
__decorate([
    literalProperty({
        path: profilePlus.hasSacredText,
        required: false,
        // maxCount: 5,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "sacredTexts", null);
__decorate([
    literalProperty({
        path: profilePlus.hasMayanAstrology,
        required: false,
        // maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "mayanAstrology", null);
__decorate([
    literalProperty({
        path: profilePlus.hasChineseZodiac,
        required: false,
        // maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "chineseZodiac", null);
__decorate([
    literalProperty({
        path: profilePlus.hasPersonalityType,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "myersBriggsPersonalityType", null);
__decorate([
    literalProperty({
        path: profilePlus.hasLoveLanguage1,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "loveLanguage1", null);
__decorate([
    literalProperty({
        path: profilePlus.hasLoveLanguage2,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "loveLanguage2", null);
__decorate([
    literalProperty({
        path: profilePlus.hasLoveLanguage3,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "loveLanguage3", null);
__decorate([
    literalProperty({
        path: profilePlus.hasLoveLanguage4,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "loveLanguage4", null);
__decorate([
    literalProperty({
        path: profilePlus.hasLoveLanguage5,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "loveLanguage5", null);
__decorate([
    literalProperty({
        path: profilePlus.hasSpiritualJourney,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "spiritualJourney", null);
Person = __decorate([
    linkedShape
], Person);
export { Person };
//# sourceMappingURL=Person.js.map